import React from 'react';
import Link from '@atlaskit/link';
import { FormattedMessage } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const SignInRedirect = () => (
	<FormattedMessage
		{...messages.signIn}
		values={{
			link: (msg) => (
				// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
				<Link href={`/login.jsp?os_destination=${window.location.href}`}>{msg}</Link>
			),
		}}
	/>
);
